import styled from '@emotion/styled'

export const MainContainer = styled.div((props) => ({
  maxWidth: '768px',
  margin: 'auto',
  paddingBottom: '100px',
}))
